import moment from 'moment';
import * as types from './types';
import Immutable from 'seamless-immutable';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = Immutable({
  //Used by default EX on VG Select
  list: [],
  pagination: {},
  loadingList: null,
  //Used for VG on user/customer page
  user: [],
  userPagination: {},
  userLoading: false,
  //Used for VG assign/modal list
  modal: [],
  modalPagination: {},
  modalLoading: false,
  saList: [],
  vgList: [],
  current: {},
  bhTimes: null,
  timezones: [],
  loading: null,
  rrsTimes: [],
  fleetSaList: [],
  fleetVgList: [],
  relatedRulesets: [],
  fetchingRRStimes: false,
  fetchCreateVehicleGroupSuccess: false,
  fetchUpdateVehicleGroupSuccess: FETCH_STATE.UNSENT,
  errors: {},
  onboarding: {
    exitOnboarding: false,
    currentGroup: '',
    lastStep: false,
    exitStep: false,
    position: 0,
    errors: {},
    steps: {},
  },
  // Feet Share/Unshare list
  availableFleets: [],
  availableFleetsPagination: {},
  fetchAvailableFleets: FETCH_STATE.UNSENT,
  sharedFleets: [],
  sharedFleetsPagination: {},
  fetchSharedFleets: FETCH_STATE.UNSENT,
  fetchUpdateFleets: FETCH_STATE.UNSENT,
  fetchDeleteVehicleGroup: FETCH_STATE.UNSENT,
});

const vehiclesGroupsReducer = createReducer(initialState)({
  [types.FETCH_VEHICLES_GROUPS_REQUEST]: (state, { payload }) => {
    const loading = payload === 'list' ? 'loadingList' : `${payload}Loading`;
    return {
      ...state,
      [loading]: true,
    };
  },
  [types.FETCH_VEHICLES_GROUPS_SUCCESS]: (state, { payload }) => {
    const loading = payload.type === 'list' ? 'loadingList' : `${payload.type}Loading`;
    const pagination = payload.type === 'list' ? 'pagination' : `${payload.type}Pagination`;
    return {
      ...state,
      [loading]: false,
      [payload.type]: payload.data,
      [pagination]: payload.pagination,
    };
  },
  [types.FETCH_VEHICLES_GROUPS_FAILED]: (state, { payload }) => {
    const loading = payload.type === 'list' ? 'loadingList' : `${payload.type}Loading`;
    return {
      ...state,
      [loading]: false,
    };
  },
  [types.FETCH_VEHICLES_GROUP_BY_ID_REQUEST]: (state, { payload }) => {
    let data = {
      ...state,
      loading: true,
      fetchUpdateVehicleGroupSuccess: FETCH_STATE.UNSENT,
      onboarding: {
        ...state.onboarding,
        errors: {},
      },
    };
    if (payload.key === 'current') {
      data.current = {};
    }
    return data;
  },
  [types.FETCH_VEHICLES_GROUP_BY_ID_SUCCESS]: (state, { payload }) => {
    let data = {};
    if (payload?.step) {
      data = {
        onboarding: {
          ...state.onboarding,
          steps: {
            ...state.onboarding.steps,
            [payload.step]: payload.data,
          },
        },
      };
    } else if (payload.key === 'list') {
      data = { [payload.type || payload.key]: [payload.data] };
    } else {
      data = { [payload.key]: payload.data };
    }
    return {
      ...state,
      loading: false,
      ...data,
    };
  },
  [types.FETCH_VEHICLES_GROUP_BY_ID_FAILED]: (state, payload) => {
    return {
      ...state,
      loading: false,
      current: {},
      onboarding: {
        ...state.onboarding,
        errors: payload?.errors || {},
      },
    };
  },

  [types.FETCH_CREATE_VEHICLE_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchCreateVehicleGroupSuccess: false,
      onboarding: {
        ...state.onboarding,
        errors: {},
      },
    };
  },
  [types.FETCH_CREATE_VEHICLE_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchCreateVehicleGroupSuccess: true,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          [payload.step]: payload.data,
        },
      },
    };
  },
  [types.FETCH_CREATE_VEHICLE_GROUPS_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchCreateVehicleGroupSuccess: false,
      onboarding: {
        ...state.onboarding,
        errors: payload?.errors || {},
      },
    };
  },

  [types.FETCH_UPDATE_VEHICLE_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchUpdateVehicleGroupSuccess: FETCH_STATE.LOADING,
      errors: {},
    };
  },
  [types.FETCH_UPDATE_VEHICLE_GROUPS_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchUpdateVehicleGroupSuccess: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_UPDATE_VEHICLE_GROUPS_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchUpdateVehicleGroupSuccess: FETCH_STATE.ERROR,
      errors: payload?.errors || {},
    };
  },

  [types.FETCH_UPDATE_STEP_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      onboarding: {
        ...state.onboarding,
        errors: {},
      },
    };
  },
  [types.FETCH_UPDATE_STEP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          [payload.step]: payload.data,
        },
      },
    };
  },
  [types.FETCH_UPDATE_STEP_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        errors: payload?.errors || {},
      },
    };
  },

  [types.UPDATE_STEPS_LISTS_REQUEST]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName } = payload;

    return {
      ...state,
      loading: true,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              ...onboarding?.steps?.[step]?.[listName],
              list: [],
              loading: true,
            },
          },
        },
        errors: {},
      },
    };
  },
  [types.UPDATE_STEPS_LISTS_SUCCESS]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName } = payload;

    return {
      ...state,
      loading: false,
      position: 0,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              loading: false,
              ...payload.data,
            },
          },
        },
      },
    };
  },
  [types.UPDATE_STEPS_LISTS_FAILED]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName, errors } = payload;
    return {
      ...state,
      loading: false,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              ...state?.onboarding?.steps?.[step]?.[listName],
              loading: false,
            },
          },
        },
        errors: errors,
      },
    };
  },

  [types.FETCH_ADD_ITEM_TO_VEHICLES_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_ADD_ITEM_TO_VEHICLES_GROUPS_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_ADD_ITEM_TO_VEHICLES_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_REQUEST]: (state, { payload }) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_VEHICLE_GROUPS_ACTIVATION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_ACTIVATION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        lastStep: true,
      },
    };
  },
  [types.FETCH_VEHICLE_GROUPS_ACTIVATION_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        lastStep: true,
        errors: payload.errors,
      },
    };
  },

  [types.FETCH_RELATED_RULESETS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_RELATED_RULESETS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      relatedRulesets: payload,
    };
  },
  [types.FETCH_RELATED_RULESETS_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_VEHICLE_GROUPS_RRS_TIMES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingRRStimes: true,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_RRS_TIMES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingRRStimes: false,
      rrsTimes: payload,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_RRS_TIMES_FAILED]: (state) => {
    return {
      ...state,
      fetchingRRStimes: false,
    };
  },

  [types.FETCH_VEHICLE_GROUPS_BH_TIMES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingBHTimes: true,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_BH_TIMES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingBHTimes: false,
      bhTimes: payload,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_BH_TIMES_FAILED]: (state) => {
    return {
      ...state,
      fetchingBHTimes: false,
    };
  },

  [types.FETCH_VEHICLE_GROUPS_TIMEZONES_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_TIMEZONES_SUCCESS]: (state, { payload }) => {
    const data = [...payload];
    const existsGuessTZ = payload?.find((t) => t?.time_zone === moment.tz.guess());
    if (!existsGuessTZ) {
      data.unshift({ time_zone: moment.tz.guess() });
    }
    return {
      ...state,
      loading: false,
      timezones: data,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_TIMEZONES_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.CHANGE_POSITION]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        position: payload.position,
      },
    };
  },

  [types.RESET_ONBOARDING]: (state, { payload }) => {
    return {
      ...state,
      list: [],
      fetchCreateVehicleGroupSuccess: false,
      onboarding: {
        position: payload?.type === 'reset' ? null : 0,
        exitOnboarding: false,
        currentGroup: '',
        exitStep: false,
        lastStep: false,
        errors: {},
        steps: {},
      },
    };
  },

  [types.SET_EXIT]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        [payload.type]: payload.exit,
      },
    };
  },
  [types.RESET_VEHICLE_GROUPS_OPTIONS]: (state) => {
    return {
      ...state,
      list: [],
      user: [],
    };
  },

  // Feet List/Share/Unshare services
  [types.FETCH_AVAILABLE_SERVICES_REQUEST]: (state) => ({
    ...state,
    fetchAvailableServices: FETCH_STATE.LOADING,
  }),
  [types.FETCH_AVAILABLE_SERVICES_SUCCESS]: (state, { payload }) => ({
    ...state,
    fetchAvailableServices: FETCH_STATE.DONE,
    availableServices: payload.data,
    availableServicesPagination: payload.pagination,
  }),
  [types.FETCH_AVAILABLE_SERVICES_FAILED]: (state) => ({
    ...state,
    fetchAvailableServices: FETCH_STATE.ERROR,
  }),
  [types.FETCH_SHARED_SERVICES_REQUEST]: (state) => ({
    ...state,
    fetchSharedServices: FETCH_STATE.LOADING,
    fetchUpdateFleets: FETCH_STATE.UNSENT,
  }),
  [types.FETCH_SHARED_SERVICES_SUCCESS]: (state, { payload }) => ({
    ...state,
    fetchSharedServices: FETCH_STATE.DONE,
    sharedServices: payload.data,
    sharedServicesPagination: payload.pagination,
  }),
  [types.FETCH_SHARED_SERVICES_FAILED]: (state) => ({
    ...state,
    fetchSharedServices: FETCH_STATE.ERROR,
  }),
  [types.FETCH_UPDATE_FLEET_REQUEST]: (state) => ({
    ...state,
    fetchUpdateFleets: FETCH_STATE.LOADING,
  }),
  [types.FETCH_UPDATE_FLEET_SUCCESS]: (state) => ({
    ...state,
    fetchUpdateFleets: FETCH_STATE.DONE,
  }),
  [types.FETCH_UPDATE_FLEET_FAILED]: (state) => ({
    ...state,
    fetchUpdateFleets: FETCH_STATE.ERROR,
  }),
  [types.FETCH_DELETE_VEHICLE_GROUP_REQUEST]: (state) => ({
    ...state,
    fetchDeleteVehicleGroup: FETCH_STATE.LOADING,
  }),
  [types.FETCH_DELETE_VEHICLE_GROUP_SUCCESS]: (state) => ({
    ...state,
    fetchDeleteVehicleGroup: FETCH_STATE.DONE,
  }),
  [types.FETCH_DELETE_VEHICLE_GROUP_FAILURE]: (state) => ({
    ...state,
    fetchDeleteVehicleGroup: FETCH_STATE.ERROR,
  }),
});

export default vehiclesGroupsReducer;
